/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBookingSequentialSlotsQueryResponse, GetApiBookingSequentialSlotsQueryParams } from "../entities/GetApiBookingSequentialSlots";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiBookingSequentialSlots } from "../api/getApiBookingSequentialSlots";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiBookingSequentialSlotsQueryKey = (params: GetApiBookingSequentialSlotsQueryParams) => [{ url: '/api/booking/sequential/slots' }, ...(params ? [params] : [])] as const

export type GetApiBookingSequentialSlotsQueryKey = ReturnType<typeof getApiBookingSequentialSlotsQueryKey>

export function getApiBookingSequentialSlotsQueryOptions(params: GetApiBookingSequentialSlotsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiBookingSequentialSlotsQueryKey(params)
        return queryOptions<GetApiBookingSequentialSlotsQueryResponse, ResponseErrorConfig<Error>, GetApiBookingSequentialSlotsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiBookingSequentialSlots(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Возвращает комбинации времени и мастеров для последовательной записи
 * @summary Получить доступные слоты для последовательной записи
 * {@link /api/booking/sequential/slots}
 */
export function useGetApiBookingSequentialSlots<TData = GetApiBookingSequentialSlotsQueryResponse, TQueryData = GetApiBookingSequentialSlotsQueryResponse, TQueryKey extends QueryKey = GetApiBookingSequentialSlotsQueryKey>(params: GetApiBookingSequentialSlotsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiBookingSequentialSlotsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiBookingSequentialSlotsQueryKey(params)
         

         const query = useQuery({
          ...getApiBookingSequentialSlotsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}